import confetti from "canvas-confetti";

const CONFETTI_COLORS = ["#10b981", "#2563eb", "#f59e0b", "#f8fafc"];

function prefersReducedMotion() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
}

export function fireConfetti() {
  if (prefersReducedMotion()) {
    return;
  }

  confetti({
    particleCount: 70,
    spread: 58,
    startVelocity: 34,
    gravity: 0.9,
    ticks: 170,
    scalar: 0.85,
    origin: { y: 0.68 },
    colors: CONFETTI_COLORS,
    disableForReducedMotion: true,
  });
}
